var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValueOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7969,
    width: 57.1404,
    height: 57.1404,
    rx: 15,
    transform: "rotate(15 14.7969 0)",
    fill: "#4060EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8032_16595)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 57,
    height: 57,
    rx: 15,
    fill: "white",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7269 52.416C21.4255 52.416 20.2415 52.1173 19.1749 51.52C18.1082 50.912 17.1855 50.0747 16.4069 49.008C15.6389 47.9413 15.0469 46.7093 14.6309 45.312C14.2149 43.904 14.0069 42.4 14.0069 40.8C14.0069 39.2 14.2149 37.7013 14.6309 36.304C15.0469 34.896 15.6389 33.6587 16.4069 32.592C17.1855 31.5253 18.1082 30.6933 19.1749 30.096C20.2415 29.488 21.4255 29.184 22.7269 29.184C24.0282 29.184 25.2122 29.488 26.2789 30.096C27.3455 30.6933 28.2575 31.5253 29.0149 32.592C29.7829 33.6587 30.3749 34.896 30.7909 36.304C31.2175 37.7013 31.4309 39.2 31.4309 40.8C31.4309 42.4 31.2175 43.904 30.7909 45.312C30.3749 46.7093 29.7829 47.9413 29.0149 49.008C28.2575 50.0747 27.3455 50.912 26.2789 51.52C25.2122 52.1173 24.0282 52.416 22.7269 52.416ZM22.7269 48.512C23.8682 48.512 24.8122 48.1493 25.5589 47.424C26.3055 46.6987 26.8602 45.7493 27.2229 44.576C27.5855 43.4027 27.7669 42.144 27.7669 40.8C27.7669 39.3813 27.5749 38.0907 27.1909 36.928C26.8069 35.7547 26.2415 34.8213 25.4949 34.128C24.7482 33.4347 23.8255 33.088 22.7269 33.088C21.8629 33.088 21.1109 33.3013 20.4709 33.728C19.8415 34.144 19.3189 34.7147 18.9029 35.44C18.4869 36.1653 18.1775 36.992 17.9749 37.92C17.7722 38.8373 17.6709 39.7973 17.6709 40.8C17.6709 42.1333 17.8522 43.392 18.2149 44.576C18.5882 45.7493 19.1482 46.6987 19.8949 47.424C20.6522 48.1493 21.5962 48.512 22.7269 48.512ZM36.4866 52V33.504H33.6706L34.7266 29.6H40.3906V52H36.4866Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8032_16595",
    x: -24,
    y: -11,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8032_16595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8032_16595",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueOne);
export default __webpack_public_path__ + "static/media/ValueOne.e3303971f610d542f2afdd1bf16517c7.svg";
export { ForwardRef as ReactComponent };